import { RouteConfig } from 'vue-router'
import { requireAuth } from '../auth'
import { ghlSwagRoutes } from '../constants/agency/'

// Route for GHL Swag
export const ghlSwag: RouteConfig[] = [
    {
        path: '/ghl-swag',
        name: ghlSwagRoutes.default,
        meta: {
            RedirectExternalUrl: 'https://swag.gohighlevel.com/?utm_source=app.gohighlevel.com&utm_medium=app&utm_campaign=app_to_store/',
        },
        beforeEnter: requireAuth,
    },
]